import React from "react";
import { useNavigate } from "react-router-dom";
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";
import { formatTimestamp } from "../../../utils/helper";

const FBT_MSNS_PREVIEW_LENGTH = 50;

export const FbtStatusPill = (props: { value: any }) => {
    const isActive = props.value === true || props.value === "true"
    return (
        <span className={`inline-block whitespace-nowrap px-1.5 py-0.5 rounded text-[11px] font-medium border ${isActive ? "bg-green-100 text-green-800 border-green-200" : "bg-red-100 text-red-800 border-red-200"}`}>
            {isActive ? "Active" : "Inactive"}
        </span>
    )
}

const FbtListItem = (props: any) => {
    const navigate = useNavigate()
    const { data } = props

    const updateFbtNavigateHandler = (id: any) => {
        navigate(`/fbt/${id}`)
    }

    // The MSN list is long enough to break the row; the full value stays
    // available on hover.
    const previewFbtMsns = (fbtMsns: any) => {
        const value = fbtMsns || ""
        return value.length > FBT_MSNS_PREVIEW_LENGTH
            ? `${value.slice(0, FBT_MSNS_PREVIEW_LENGTH)}…`
            : value
    }

    if (!data.length) {
        return (
            <tr>
                <td colSpan={7} className="px-4 py-12 text-center text-xs text-gray-500">No FBT mappings found.</td>
            </tr>
        )
    }

    return (
        <>
            {data.map((_d: any) =>
                <tr key={_d.id} className='[&:nth-child(odd)]:bg-[#f7f7f7]'>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium">{_d.id}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.msn}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]" title={_d.fbtMsns}>{previewFbtMsns(_d.fbtMsns)}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">{formatTimestamp(_d.createdAt)}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] whitespace-nowrap">{formatTimestamp(_d.modifiedAt)}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">
                        <FbtStatusPill value={_d.isActive} />
                    </td>
                    <td className="px-4 py-3">
                        <button
                            onClick={() => updateFbtNavigateHandler(_d.id)}
                            className="text-blue-600 hover:text-blue-800 transition-colors"
                            title="Update"
                        >
                            <Edit2FillIcon size={16} />
                        </button>
                    </td>
                </tr>)}
        </>
    )
}
export default FbtListItem;
